// extracted by mini-css-extract-plugin
module.exports = {"box":"box--+JT-T","carousel":"carousel--CMBYK","tit":"tit--t8w28"};